(function (Drupal, drupalSettings) {
  "use strict";
  let panel;
  let langueElement;
  let languageSwitcherToFocus;

  Drupal.behaviors.languageSwitcher = {
    attach: function (context, settings) {
      const languageSwitcher = once(
        "oncedLanguageSwitcher",
        document.getElementById("block-passpass-languageswitcher")
      )[0];
      if (languageSwitcher) {
        const currentLanguageCode = document
          .querySelector("html")
          .getAttribute("lang");

        langueElement = languageSwitcher.querySelector("h2");
        languageSwitcherToFocus = langueElement;
        langueElement.tabIndex = 0;
        panel = languageSwitcher.querySelector(".links");
        var lang = document.createElement("div");
        panel.style.opacity = "0";
        panel.style.padding = "0";

        languageSwitcher.addEventListener("click", togglePanel);
        languageSwitcher.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            togglePanel();
            event.preventDefault();
          } else if (event.key === "Escape") {
            closePanel();
          } else if (event.key === "Tab" && panel.style.opacity === "1") {
            const links = panel.querySelectorAll("a");
            const firstLink = links[0];
            const lastLink = links[links.length - 1];
            if (event.shiftKey && document.activeElement === firstLink) {
              event.preventDefault();
              lastLink.focus();
            } else if (!event.shiftKey && document.activeElement === lastLink) {
              event.preventDefault();
              firstLink.focus();
            }
          }
        });

        panel.querySelectorAll("a").forEach(function (link) {
          link.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
              link.click();
            }
          });
        });

        if(currentLanguageCode != null) {
          langueElement.innerText = currentLanguageCode.toUpperCase();
        } else {
          langueElement.innerText = "FR";
        }
      }
    },
  };

  function closePanel() {
    panel.style.opacity = "0";
    panel.style.height = "0";
    panel.style.padding = "0";
    panel.style.display = "none";
    langueElement.classList.remove("modified");
    languageSwitcherToFocus.focus();
  }

  function togglePanel() {
    if (panel.style.opacity === "0") {
      panel.style.opacity = "1";
      panel.style.display = "flex";
      panel.style.height = "fit-content";
      panel.style.padding = "2rem 2rem 1rem 2rem";
      langueElement.classList.add("modified");
      panel.focus();
    } else {
      closePanel();
    }
  }
})(Drupal, drupalSettings);